<template>
  <div>
    <UploadAddressAndIdentityVerification></UploadAddressAndIdentityVerification>
  </div>
</template>

<script>
import UploadAddressAndIdentityVerification from "@components/investor/contract-levels/UploadAddressAndIdentityVerification";
export default {
  name: "IncrementInvestorContractLevel",
  components: {
    UploadAddressAndIdentityVerification
  },
  data() {
    return {
    }
  }
}
</script>